export default __webpack_public_path__ + "static/banner-23e26ddd43a25653ee0e316f27ae6bb0.jpg";